import { render, staticRenderFns } from "./ProposalList.vue?vue&type=template&id=46a93f4a"
import script from "./ProposalList.vue?vue&type=script&lang=js"
export * from "./ProposalList.vue?vue&type=script&lang=js"
import style0 from "./ProposalList.vue?vue&type=style&index=0&id=46a93f4a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports